/**
 * WordPress dependencies
 */
import { useMergeRefs } from '@wordpress/compose';
import { forwardRef, useRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import RadioControl from '../../radio-control';
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedRadioControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    required: required,
    markWhenOptional: markWhenOptional
    // TODO: Upstream limitation - RadioControl does not accept a ref.
    ,
    ref: mergedRefs,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current?.querySelector('input[type="radio"]'),
    children: /*#__PURE__*/_jsx(RadioControl, {
      ...restProps
    })
  });
};
export const ValidatedRadioControl = forwardRef(UnforwardedValidatedRadioControl);